module.exports = __webpack_public_path__ + "static/media/icon_file_doc.868f0877.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_doc.svg
// module id = 154
// module chunks = 0